<div class="modal-body form-content text-center ">
  <p class="para form-group">{{ message }}</p>
  <div class="edit_popup_button edit_dislog_btn">
    <button type="button" class="btn btn-primary" [class.hide_btn]="btnCancelText==''" (click)="decline()">{{
      btnCancelText }}</button>
    <button type="button" class="btn btn-cancel" (click)="accept()">{{ btnOkText }}</button>
  </div>
</div>